export default __webpack_public_path__ + "static/media/RotateRight.9d406046.svg";